import * as React from 'react';
import { HybridLinkProps, NavigationPush } from '@westwing/appshell_types';
import useAppShell from '.';

export const HybridLink: React.FC<HybridLinkProps> = props => {
    const { children } = props;
    const {
        routingHelpers: { HybridLink: HybridLinkComponent },
    } = useAppShell();

    return <HybridLinkComponent {...props}>{children}</HybridLinkComponent>;
};

export const useAppShellPush = (): NavigationPush => {
    const { routingHelpers } = useAppShell();
    return routingHelpers.useBellaPush;
};
